module.exports = __webpack_public_path__ + "img/tt_s_n.ab92a8ef.webp";